/************************* Get Entity *************************/
export const ENTITY_LOADING = 'ENTITY_LOADING';
export const ENTITY_SUCCESS = 'ENTITY_SUCCESS';
export const ENTITY_FAILURE = 'ENTITY_FAILURE';
export const ENTITY_CLEAR = 'ENTITY_CLEAR';

/************************* Entity Form *************************/
export const SET_ENTITY_FORM_LANGUAGE_CODE = 'SET_ENTITY_FORM_LANGUAGE_CODE';
